export * from './bar-chart.module';
export * from './bar.component';
export * from './bar-horizontal.component';
export * from './bar-horizontal-2d.component';
export * from './bar-horizontal-normalized.component';
export * from './bar-horizontal-stacked.component';
export * from './series-horizontal.component';

export * from './bar-label.component';

export * from './bar-vertical.component';
export * from './bar-vertical-2d.component';
export * from './bar-vertical-normalized.component';
export * from './bar-vertical-stacked.component';
export * from './series-vertical.component';
